import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound, Eye, EyeOff, Loader2 } from "lucide-react";

export default function ChangePasswordCard() {
    const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
    const [show, setShow] = useState(false);
    const [saving, setSaving] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (form.new_password.length < 8) return toast.error("A nova palavra-passe deve ter pelo menos 8 caracteres");
        if (form.new_password !== form.confirm) return toast.error("As palavras-passe não coincidem");
        if (form.new_password === form.current_password) return toast.error("A nova palavra-passe tem de ser diferente da atual");
        setSaving(true);
        try {
            await api.put("/auth/password", {
                current_password: form.current_password,
                new_password: form.new_password,
            });
            toast.success("Palavra-passe alterada com sucesso");
            setForm({ current_password: "", new_password: "", confirm: "" });
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Erro ao alterar a palavra-passe");
        } finally {
            setSaving(false);
        }
    };

    return (
        <form onSubmit={submit} className="bg-white rounded-xl border border-stone-200 p-6" data-testid="change-password-card">
            <div className="flex items-center gap-2 mb-2">
                <KeyRound className="w-4 h-4 text-[hsl(var(--copper))]" />
                <h2 className="font-display font-bold text-lg">Alterar palavra-passe</h2>
            </div>
            <p className="text-sm text-stone-500 mb-5">Mínimo 8 caracteres. Depois de guardar, a sessão continua ativa neste dispositivo, mas outros dispositivos com sessão iniciada serão desligados.</p>

            <div className="space-y-3">
                <Field label="Palavra-passe atual" testid="cp-current"
                    value={form.current_password} type={show ? "text" : "password"}
                    onChange={(v) => setForm({ ...form, current_password: v })} />
                <Field label="Nova palavra-passe" testid="cp-new"
                    value={form.new_password} type={show ? "text" : "password"}
                    onChange={(v) => setForm({ ...form, new_password: v })} />
                <Field label="Confirmar nova palavra-passe" testid="cp-confirm"
                    value={form.confirm} type={show ? "text" : "password"}
                    onChange={(v) => setForm({ ...form, confirm: v })} />
            </div>

            <div className="flex items-center justify-between mt-5">
                <button type="button" onClick={() => setShow((s) => !s)}
                    className="text-xs text-stone-500 hover:text-stone-800 inline-flex items-center gap-1">
                    {show ? <><EyeOff className="w-3.5 h-3.5" /> Ocultar</> : <><Eye className="w-3.5 h-3.5" /> Mostrar</>}
                </button>
                <button type="submit" disabled={saving} data-testid="cp-submit" className="btn-copper !py-2 !px-4 text-sm disabled:opacity-50">
                    {saving ? <><Loader2 className="w-4 h-4 animate-spin" /> A guardar…</> : "Guardar palavra-passe"}
                </button>
            </div>
        </form>
    );
}

function Field({ label, value, onChange, type, testid }) {
    return (
        <label className="block">
            <span className="text-xs uppercase tracking-wider text-stone-500 block mb-1">{label}</span>
            <input type={type} value={value} onChange={(e) => onChange(e.target.value)} required
                data-testid={testid}
                className="w-full border border-stone-300 rounded p-2 text-sm font-mono" autoComplete="new-password" />
        </label>
    );
}
